/**
 * Persistence helpers for the Five9 slice.
 *
 * Keeps the fields needed to reconstruct a call/dispatch link after a reload
 * (or when broadcasting to peer tabs). Notably drops the `raw` SDK payload
 * -- that''s a fresh object every event and has no business surviving
 * serialization to sessionStorage or a BroadcastChannel message.
 *
 * @typedef {import('src/type-defs/five9Types').Five9Call} Five9Call
 */
/**
 * @param {Five9Call | undefined | null} call
 * @returns {Partial<Five9Call>}
 */
export default function stripPersistableCall(call) {
  if (!call) return {};
  return {
    callSid: call.callSid,
    ...(call.number ? { number: call.number } : {}),
    ...(call.phoneNumber ? { phoneNumber: call.phoneNumber } : {}),
    ani: call.ani ?? null,
    dnis: call.dnis ?? null,
    state: call.state ?? null,
    // Same-tab reload hydration and the non-owner-tab display badges
    // (adapter header / log panel) pick the display number by direction.
    // The TopBar chip and action components stay owner-tab-only by design.
    ...(call.direction ? { direction: call.direction } : {}),
    ...(call.callState ? { callState: call.callState } : {}),
    ...(call.screenpopCore && Object.keys(call.screenpopCore).length
      ? { screenpopCore: call.screenpopCore }
      : {}),
    associatedDispatchId: call.associatedDispatchId ?? null,
    startedAt: call.startedAt ?? null,
    ...(call.endedAt ? { endedAt: call.endedAt } : {}),
    lastEventAt: call.lastEventAt ?? null
  };
}
